import { MdClose } from 'react-icons/md';
import { useEffect, useState } from 'react';
import { InlineWidget } from 'react-calendly';

const WelcomeSellerModal = (props: {
    isOpen: boolean;
    onClose: () => void;
    onSignUp: () => void;
}) => {
    const { isOpen, onClose, onSignUp } = props;
    const [showIframe, setShowIframe] = useState(false);

    useEffect(() => {
        if (!isOpen) setShowIframe(false);
    }, [isOpen]);

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-[1000] flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="relative z-[1002] flex max-h-[90vh] w-full max-w-[700px] flex-col p-4">
                <div className="relative flex flex-col overflow-y-auto rounded-xl border border-leadrs-stroke bg-white px-6 pb-6 pt-6 shadow-2xl">
                    <button
                        className="absolute right-4 top-4 z-10 text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                        onClick={onClose}
                    >
                        <MdClose size={18} />
                    </button>

                    {!showIframe ? (
                        <>
                            <div className="mb-6 rounded-xl border border-leadrs-stroke bg-leadrs-bg p-6">
                                <h2 className="mb-4 font-crimson text-[28px] font-bold leading-tight text-leadrs-text text-center">
                                    Chez nous, les prix ne s'affichent pas. Ils se définissent.
                                </h2>
                                <div className="space-y-4 font-geist text-sm leading-relaxed text-leadrs-text-soft">
                                    <p>
                                        Leadrs n'est pas un catalogue de leads avec des tarifs imposés.
                                        C'est une marketplace intelligente où vous décidez du prix que vous êtes prêt à payer, selon votre rentabilité et votre stratégie.
                                    </p>
                                    <p>
                                        Nos algorithmes de matching attribuent les leads en fonction de votre positionnement, de votre scoring et de votre prix cible.
                                    </p>
                                    <p className="font-semibold text-leadrs-text">
                                        Vous voulez voir comment ça fonctionne ?
                                    </p>
                                </div>
                            </div>

                            <div className="space-y-3">
                                <button
                                    onClick={onSignUp}
                                    className="w-full rounded-xl bg-leadrs-brand px-6 py-4 font-geist text-sm font-bold text-white transition-opacity hover:opacity-80"
                                >
                                    Créer mon compte
                                </button>
                                <button
                                    onClick={() => setShowIframe(true)}
                                    className="w-full rounded-xl border border-leadrs-brand px-6 py-4 font-geist text-sm font-bold text-leadrs-brand transition-opacity hover:opacity-80"
                                >
                                    Prendre rendez-vous avec un expert Leadrs
                                </button>
                            </div>

                            <div className="mt-4 text-center">
                                <button
                                    onClick={onClose}
                                    className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                                >
                                    Je découvre la plateforme
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="mb-4 mt-6">
                                <h3 className="mb-2 text-center font-crimson text-xl font-semibold text-leadrs-text">
                                    Planifiez un appel avec notre équipe
                                </h3>
                                <p className="mb-4 text-center font-geist text-sm text-leadrs-text-soft">
                                    Discutons de vos besoins et découvrez comment Leadrs peut vous aider à générer plus de business.
                                </p>
                                <div className="overflow-hidden rounded-xl border border-leadrs-stroke">
                                    <InlineWidget
                                        url="https://calendly.com/lewis-weareleadrs/30min"
                                        styles={{ height: '700px', minWidth: '320px' }}
                                    />
                                </div>
                            </div>
                            <div className="mt-4 text-center">
                                <button
                                    onClick={() => setShowIframe(false)}
                                    className="font-geist text-sm text-leadrs-text-soft transition-colors hover:text-leadrs-text"
                                >
                                    Retour
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WelcomeSellerModal;
